import { Injectable } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import * as firebase from 'firebase/app';
import { UserProfileService } from './user-profile.service';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private currentUser: any;

  constructor(
    public afAuth: AngularFireAuth,
    private router: Router,
    private userProfileService: UserProfileService,
    private messageService: MessageService
  ) { }

  createNewUser(email, password, firstname, lastname) {
    return new Promise<any>((resolve, reject) => {
      firebase.auth().createUserWithEmailAndPassword(email, password)
        .then(res => {
          this.sendEmailVerification(true, email, firstname, lastname); // send account verification email
        });
      });
  }

  sendEmailVerification(canNavigate: boolean, email?, firstname?, lastname?) {
    const user: firebase.User = firebase.auth().currentUser;
    // set the continue URL for verification email
    const actionCodeSettings: firebase.auth.ActionCodeSettings = {
      url: `http://${environment.base_url}/userwelcome`, // TODO: this might break testing from localhost
    };

    user.sendEmailVerification(actionCodeSettings)
      .then(() => {
        if (canNavigate) { // only navigate on the initial seding of email verification
          this.userProfileService.addEmptyUserProfile(user.uid, email, firstname, lastname)
            .then((userProfile: any) => {
            })
            .catch(function(error) {
            });
          this.router.navigate([`/emailverification`]);
        }
      }).catch(() => {
        this.messageService.add({severity: 'error', summary: 'error', detail: 'Verification email could not be sent.'});
      });
  }

  sendPasswordResetEmail(emailAddress: string) {
    const auth = firebase.auth();

    const actionCodeSettings: firebase.auth.ActionCodeSettings = {
      url: `http://${environment.base_url}/login`, // TODO: this might break testing from localhost
    };

    auth.sendPasswordResetEmail(emailAddress, actionCodeSettings).then(() => {
      this.messageService.add({key: 'info', severity: 'success', summary: 'Email Sent',
      detail: 'Passsword reset email has been sent.'});
      this.router.navigate(['/login']);
    }).catch(() => {
      this.messageService.add({key: 'info', severity: 'error', summary: 'Email Error',
      detail: 'Passsword reset email could not be sent.'});
    });
  }

  changePassword(newPassword: string): Promise<any> {
    const user = firebase.auth().currentUser;

    return user.updatePassword(newPassword);
  }

  doLogin(email, password) {
    return new Promise<any>((resolve, reject) => {
      firebase.auth().signInWithEmailAndPassword(email, password)
        .then(res => {
          resolve(res);
        }, err => reject(err));
    });
  }

  doLogout() {
    return new Promise((resolve, reject) => {
      if (firebase.auth().currentUser) {
        this.afAuth.auth.signOut();
        resolve({});
      } else {
        reject();
      }
    });
  }

  doGoogleLogin() {
    return new Promise<any>((resolve, reject) => {
      const provider = new firebase.auth.GoogleAuthProvider();
      provider.addScope('profile');
      provider.addScope('email');
      this.afAuth.auth
      .signInWithPopup(provider)
      .then(res => {
        const isNewUser = res.additionalUserInfo.isNewUser;
        if (isNewUser) {
          const uId = res.user.uid;
          const email = res.additionalUserInfo.profile['email'] || '';
          const firstname = res.additionalUserInfo.profile['given_name'] || '';
          const lastname = res.additionalUserInfo.profile['family_name'] || '';
          this.userProfileService.addEmptyUserProfile(uId, email, firstname, lastname)
            .then((userProfile: any) => {
            })
            .catch(function(error) {
            });
        }
        resolve(res);
      }, err => {
        reject(err);
      });
    });
  }

  setCurrentUser(user: firebase.User | any) {
    localStorage.setItem('currentUser', JSON.stringify(user));
    this.currentUser = user;

    const currentFSUser = firebase.auth().currentUser;
    if (currentFSUser) {
      currentFSUser.getIdToken()
        .then((resp) => {
          this.currentUser.authType = 'Bearer';
          this.currentUser.authToken = resp;
          localStorage.setItem('currentUser', JSON.stringify(this.currentUser));
        });
    }
  }

  getCurrentUser(): any {
    this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
    return this.currentUser;
  }

  getAuthToken(): string {
    this.currentUser = JSON.parse(localStorage.getItem('currentUser'));

    if (this.currentUser && this.currentUser.authToken) {
      return this.currentUser.authToken;
    }

    return '';
  }

  refreshToken(): Promise<any> {
    this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
    const currentFSUser = firebase.auth().currentUser;
    if (currentFSUser) {
      return currentFSUser.getIdToken(true)
        .then((resp) => {
          this.currentUser.authType = 'Bearer';
          this.currentUser.authToken = resp;
          return this.currentUser;
        });
    } else {
      return Promise.reject(null);
    }
  }

}
